export enum IndustryType {
  FoodAndBeverage = "foodAndBeverage",
  TextilesAndApparel = "textilesAndApparel",
  WoodProducts = "woodProducts",
  PulpAndPaper = "pulpAndPaper",
  Printing = "printing",
  PetroleumAndCoalProducts = "petroleumAndCoalProducts",
  Chemicals = "chemicals",
  PlasticsAndRubber = "plasticsAndRubber",
  NonmetallicMineralProducts = "nonmetallicMineralProducts",
  PrimaryMetals = "primaryMetals",
  FabricatedMetals = "fabricatedMetals",
  MachineryManufacturing = "machineryManufacturing",
  ComputerAndElectronicProducts = "computerAndElectronicProducts",
  ElectricalEquipmentAppliancesAndComponents = "electricalEquipmentAppliancesAndComponents",
  TransportationEquipment = "transportationEquipment",
  Furniture = "furniture",
  MiscellaneousManufacturing = "miscellaneousManufacturing",
  BankingFinancial = "bankingFinancial",
  Education = "education",
  EntertainmentPublicAssembly = "entertainmentPublicAssembly",
  FoodSalesService = "foodSalesService",
  Healthcare = "healthcare",
  LodgingResidential = "lodgingResidential",
  MixedUse = "mixedUse",
  Office = "office",
  PublicServices = "publicServices",
  ReligiousWorship = "religiousWorship",
  Retail = "retail",
  Warehouse = "warehouse",
  CommercialOther = "commercialOther",
}
